module.exports = __webpack_public_path__ + "img/50.9d8cd75f.jpg";